<!--
 * @Description: 常规工作/日常事务 审批 办理
 * @Author: peifu
 * @Date: 2022-12-16 13:30:48
 * @LastEditors: PF
 * @LastEditTime: 2024-03-19 18:05:30
 * @FilePath: \ZHXY_VUE3.0\src\components\home\shenpibanlihome.vue
-->

<template>
  <div>
    <el-dialog class="wp80 hp80" v-model="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">审批中心</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="handleClose()">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 按钮区域 BEGIN -->
            <el-tabs v-model="activeNames" @tab-change="initList">
              <el-tab-pane label="待审批" name="1"></el-tab-pane>
              <el-tab-pane label="已审批" name="2"></el-tab-pane>
              <el-tab-pane label="抄送" name="3"></el-tab-pane>
              <el-tab-pane label="已发起" name="4"></el-tab-pane>
            </el-tabs>
          <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table v-if="activeNames === '1'" :data="daiShenHeList" v-loading="loading" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bdmc" align="center" show-overflow-tooltip />
              <el-table-column label="发起人" prop="sqrxm" align="center" show-overflow-tooltip />
              <el-table-column label="发起时间" prop="sqsj" width="160" align="center" show-overflow-tooltip />
              <el-table-column label="状态" prop="zt" width="120" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in spztData.list" :key="index">
                    <span v-if="scope.row.zt == item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="120" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" @click="isSPXQ=true; SPXQObj={id:scope.row.id, lx:activeNames}">审批</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
            <el-table v-if="activeNames === '2'" :data="yiShenHeList" v-loading="loading" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bdmc" align="center" show-overflow-tooltip />
              <el-table-column label="发起人" prop="sqrxm" align="center" show-overflow-tooltip />
              <el-table-column label="发起时间" prop="sqsj" width="160" align="center" show-overflow-tooltip />
              <el-table-column label="状态" prop="zt" width="120" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in spztData.list" :key="index">
                    <span v-if="scope.row.zt == item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="120" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" @click="isSPXQ=true; SPXQObj={id:scope.row.id, lx:activeNames}">查看</el-button>
                  <!-- <el-button link type="warning" @click="delDaiBan(scope.row)">删除</el-button> -->
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
            <el-table v-if="activeNames === '3'" :data="chaoSongList" v-loading="loading" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bdmc" align="center" show-overflow-tooltip />
              <el-table-column label="发起人" prop="sqrxm" align="center" show-overflow-tooltip />
              <el-table-column label="发起时间" prop="sqsj" width="160" align="center" show-overflow-tooltip />
              <el-table-column label="状态" prop="zt" width="120" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in spztData.list" :key="index">
                    <span v-if="scope.row.spsqzt == item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="120" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" @click="isSPXQ=true; SPXQObj={id:scope.row.id, lx:activeNames}">查看</el-button>
                  <!-- <el-button link type="warning" @click="delDaiBan(scope.row)">删除</el-button> -->
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
            <el-table v-if="activeNames === '4'" :data="yiFaQiList" v-loading="loading" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="标题" prop="bdmc" align="center" show-overflow-tooltip />
              <el-table-column label="发起人" prop="sqrxm" align="center" show-overflow-tooltip />
              <el-table-column label="发起时间" prop="sqsj" width="160" align="center" show-overflow-tooltip />
              <el-table-column label="状态" prop="zt" width="120" align="center" show-overflow-tooltip>
                <template #default="scope">
                  <span v-for="(item, index) in spztData.list" :key="index">
                    <span v-if="scope.row.zt == item.value">{{item.name}}</span>
                  </span>
                </template>
              </el-table-column>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="120" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="primary" @click="isXiangQing=true; xiangQingObj=scope.row">查看</el-button>
                  <!-- <el-button link type="warning" @click="delDaiBan(scope.row)">删除</el-button> -->
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <shenpixinagqing v-if="isSPXQ" v-model:isSPXQ="isSPXQ" :SPXQObj="SPXQObj" @ReturnData="initList" />
  <yifaqixinagqing v-if="isXiangQing" v-model:isXiangQing="isXiangQing" :xiangQingObj="xiangQingObj" @xiangQingReturn="initList" />
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from 'vue'
import {
  actionPost,
  actionDelete,
  loadSelect,
  homeCloseWindow
} from '@/api/common'
import { warningPrompt, successPrompt } from '@/utils/promptInfo'
import shenpixinagqing from './detail'
import yifaqixinagqing from '@/components/home/changguishiwu/tongyong/shenqing/detail.vue'

const props = defineProps({
  open: { type: String, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['openReturn', 'ReturnData'])

const daiShenHeList = ref([]) // 待审核列表
const yiShenHeList = ref([]) // 已审核列表
const chaoSongList = ref([]) // 抄送列表
const yiFaQiList = ref([]) // 已发起列表

const activeNames = ref('1') // 折叠面板

// 弹窗 开始
const isSPXQ = ref(false)
const SPXQObj = ref({})
const isXiangQing = ref(false)
const xiangQingObj = ref({})
// 弹窗 结束

// 关闭
const openList = ref(false)
const handleClose = () => {
  openList.value = false
  homeCloseWindow('openReturn', emits, false)
}
// 办理 结束

// 获取列表
const loading = ref(false)
const initList = () => {
  emits('ReturnData')
  switch (activeNames.value) {
    case '1':
      initDshList()
      break
    case '2':
      initYshList()
      break
    case '3':
      initCsList()
      break
    case '4':
      initYfqList()
      break
  }
}
const bdmc = ref()
const zt = ref()
// 待审核
const initDshList = () => {
  loading.value = true
  actionPost({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/myshenpibanli',
    data: { cxzt: 0, bdmc: bdmc.value === '' ? undefined : bdmc.value, zt: zt.value || undefined }
  }).then((res) => {
    loading.value = false
    if (res.code === 200) {
      daiShenHeList.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
// 已审核
const initYshList = () => {
  loading.value = true
  actionPost({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/myshenpibanli',
    data: { cxzt: 1, bdmc: bdmc.value === '' ? undefined : bdmc.value, zt: zt.value || undefined }
  }).then((res) => {
    loading.value = false
    if (res.code === 200) {
      yiShenHeList.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
// 抄送
const initCsList = () => {
  loading.value = true
  actionPost({
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/mychaosong',
    data: { bdmc: bdmc.value === '' ? undefined : bdmc.value, zt: zt.value || undefined }
  }).then((res) => {
    loading.value = false
    if (res.code === 200) {
      chaoSongList.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}
// 已发起
const initYfqList = () => {
  loading.value = true
  actionPost({
    url: '/api/v2/bangong/bangongshenpishenqing/faqilist',
    data: { bdmc: bdmc.value === '' ? undefined : bdmc.value, zt: zt.value || undefined }
  }).then((res) => {
    loading.value = false
    if (res.code === 200) {
      yiFaQiList.value = res.data
    } else {
      warningPrompt(res.message)
    }
  })
}

// 删除待办
const delDaiBan = (item, activeNames) => {
  const o = {
    url: '/api/v2/bangong/bangongshenpiliuzhuangbuzhou/deletecaozuoren',
    data: { id: item.id }
  }
  loading.value = true
  actionDelete(o).then((res) => {
    loading.value = false
    if (res.code === 200) {
      successPrompt(res.message)
      initList()
      activeNames.value = activeNames
    } else {
      warningPrompt(res.message)
    }
  })
}
const spztData = ref([])
watch(
  () => props.open,
  () => {
    if (props.open === 'shenpibanli') {
      openList.value = true
      loadSelect({
        url: '/api/v2/bangong/bangongshenpishenqing/shenpishenqingzhuangtai',
        data: spztData
      })
      initList()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.el-tabs__header) {
  display: block !important;
}
:deep(.el-dialog__body) {
  height: calc(100% - 120px);
  padding: 16px;
}
</style>
